<template>

  <div class="parent-server-setup">

    <h2>{{ $t('title.set-parent-server') }}</h2>

    <data-form :entity="server" :fields="fields" @submit="submit" :cancel="false" />

  </div>
</template>

<script>
import { post } from 'providers/http'

export default {
  name: 'parent-server-setup',
  props: {
    'server': {
      type: Object,
      required: true
    }
  },
  computed: {
    fields () {
      return {
        'passphrase': {
          type: 'text',
          rules: [{ required: true }]
        },
        'parent_fqdn': {
          type: 'text',
          rules: [{ required: true }]
        }
      }
    }
  },
  methods: {
    async submit ({id, passphrase, parent_fqdn}) {
      try {
        await post('api/v1/servers/set-parent', {id, passphrase, parent_fqdn})
      }
      catch (err) {
        console.error(err)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ParentServer.vue?2e97233e